import React from 'react';
import Document, { Head, Main, NextScript } from 'next/document';
import { ServerStyleSheets } from '@material-ui/core/styles';
import { ServerStyleSheet } from 'styled-components';
import * as snippet from '@segment/snippet';
import theme from '../src/theme';
// const { fetchPageInfoOnServer } = require('../server/pageTracking');

// eslint-disable-next-line no-unused-vars
export function renderSnippet(apiKey, env, req, res) {
  const opts = {
    apiKey,
    // // note: the page option only covers SSR tracking.
    // page: {
    //   properties: {
    //     properites: {
    //       ...fetchPageInfoOnServer(req, res),
    //     },
    //   },
    // },
    load: false,
  };

  if (env === 'development') {
    return snippet.max(opts);
  }

  return snippet.min(opts);
}

export default class MyDocument extends Document {
  static async getInitialProps(ctx) {
    const styledComponentsSheet = new ServerStyleSheet();
    const materialSheets = new ServerStyleSheets();
    const originalRenderPage = ctx.renderPage;

    try {
      ctx.renderPage = () =>
        originalRenderPage({
          enhanceApp: App => props => styledComponentsSheet.collectStyles(materialSheets.collect(<App {...props} />)),
        });

      const initialProps = await Document.getInitialProps(ctx);
      return {
        ...initialProps,
        ctx,
        styles: (
          <>
            {initialProps.styles}
            {materialSheets.getStyleElement()}
            {styledComponentsSheet.getStyleElement()}
          </>
        ),
      };
    } finally {
      styledComponentsSheet.seal();
    }
  }

  render() {
    const { req } = this.props.ctx;

    const language = req.language || 'en';

    return (
      <html lang={language}>
        <Head>
          <meta charSet="utf-8" />
          <meta name="viewport" content="minimum-scale=1, initial-scale=1, width=device-width, shrink-to-fit=no" />
          {/* Inject the Segment snippet into the <head> of the document  */}
          {/* PWA primary color */}
          <meta name="theme-color" content={theme.palette.primary.main} />
          {process.env.HUBSPOT_SCRIPT_LOADER_KEY && (
            <script
              type="text/javascript"
              id="hs-script-loader"
              async
              defer
              src={`//js.hs-scripts.com/${process.env.HUBSPOT_SCRIPT_LOADER_KEY}.js`}
            ></script>
          )}
        </Head>
        <body>
          <Main />
          <NextScript />
        </body>
      </html>
    );
  }
}
